import Compressor from 'compressorjs';

export const compressFile = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const isImage = ['image/jpg', 'image/jpeg', 'image/png'].includes(file?.type);

    if (isImage) {
      new Compressor(file, {
        quality: 0.7,
        maxWidth: 900,
        maxHeight: 900,
        convertSize: 0,

        success(result: File) {
          resolve(result);
        },
        error(err: Error) {
          reject(err);
        },
      });
    } else {
      resolve(file);
    }
  });
};

export const getFileType = (file: File) => {
  if (!!file.type) return file.type;
  if (file.name.includes('.rar')) return 'application/x-rar-compressed';
  if (file.name.includes('.7z')) return 'application/x-7z-compressed';
  return 'image/png';
};

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export const niceBytes = (x) => {
  let l = 0;
  let n = parseInt(x, 10) || 0;

  while (n >= 1024 && ++l) {
    n = n / 1024;
  }

  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[`${l}`];
};

export const transferSizeFileToBytes = (sizeFile: string) => {
  if (!sizeFile) return;
  const sizeFiltered = sizeFile.split(' ');
  if (sizeFiltered[1] === units[0]) {
    return Number(sizeFiltered[0] || 0);
  } else {
    switch (sizeFiltered[1]) {
      case 'KB':
        return Number(sizeFiltered[0] || 0) * 1024;
      case 'MB':
        return Number(sizeFiltered[0] || 0) * 1024 ** 2;
      case 'GB':
        return Number(sizeFiltered[0] || 0) * 1024 ** 3;
      case 'TB':
        return Number(sizeFiltered[0] || 0) * 1024 ** 4;
      case 'PB':
        return Number(sizeFiltered[0] || 0) * 1024 ** 5;
      case 'EB':
        return Number(sizeFiltered[0] || 0) * 1024 ** 6;
      case 'ZB':
        return Number(sizeFiltered[0] || 0) * 1024 ** 7;
      case 'YB':
        return Number(sizeFiltered[0] || 0) * 1024 ** 8;
      default:
        return null;
    }
  }
};
